import { useState, useEffect,useContext } from "react";
import styles from "./SupplierTable.module.css"
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../url";
import { AuthContext, AuthContextType } from "../../Auth";

export type SupplierData = {
    supplier_id: number;
    supplier: string;
    email: string;
    freeshipping: number;
}

export default function SupplierTable() {

    const navigate = useNavigate();
    const [suppliers, setSuppliers] = useState<SupplierData[]>([]);
    const [reload, setReload] = useState<boolean>(false);
    const { setAuth } = useContext(AuthContext) as AuthContextType;


 useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                    setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                    return navigate("/login");
                }
                 const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
            } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
    }, [navigate, setAuth]);

    useEffect(() => {
        const fetchSupplier = async () => {
            const response = await fetch(`${baseUrl}/getsupplier`,{
                method: "GET",
                credentials: "include",
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            setSuppliers(data);
        }

        fetchSupplier();
    }, [reload, navigate, setAuth])

    const handleEdit = async (index: number) => {
        const editsupplier = suppliers[index];
        navigate("/SupplierEditor", { state: editsupplier });
    }

    const handleDelete = async (index: number) => {
        const deletename = suppliers[index].supplier;
        if (window.confirm(`${deletename}を削除します。よろしいですか？`)) {
            try {
                const response = await fetch(`${baseUrl}/deletesupplier`, {
                    method: "DELETE",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "deletesupplier": deletename })
                })
                const data = await response.json();
                if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
                if (!response.ok) {
                    throw new Error("Network response was not OK");
                }
                alert("削除に成功しました。");
                setReload(!reload);
            } catch (error) {
                console.error(error);
            }
        } else {
            alert("削除をキャンセルしました。")
        }
    }


    return (
        <div className={styles.div}>
            <h2 className={styles.h2}>発注先リスト</h2>
            <Link to="/SupplierRegister"><Button variant="contained" size="large" style={{ fontSize: 16 }} >発注先を新規登録する</Button></Link>
            <div className={styles.scroll}>
                <table className={styles.table}>
                    <thead><tr><th className={styles.th}>発注先</th><th className={styles.th}>メールアドレス</th><th className={styles.th}>送料無料適用額</th></tr></thead>
                    <tbody>
                        {suppliers && suppliers.map((item, index) => (<tr key={index} className={styles.tr}><td className={styles.td}>{item.supplier}</td><td className={styles.td}>{item.email}</td><td className={styles.td}>{item.freeshipping}</td><td><Button key={"update" + index} onClick={() => handleEdit(index)} style={{ fontSize: 16 }}>編集</Button></td><td><Button key={"delete" + index} onClick={() => handleDelete(index)} style={{ fontSize: 16 }}>削除</Button></td></tr>))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}